<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Informations de : <br>
          <span style="font-size: 22px">{{ candidate.getFirstName() }} {{ candidate.getLastName() }}</span>
        </h1>
        <p class="text-white link-nav"><a [routerLink]="['/admin/candidats-offre/', 5]">Candidatures</a> <span
            class="lnr lnr-arrow-right"></span>
          <span> Information candidat</span>
        </p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row pb-40">

      <!-- Informations personnelles -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 65%;"> Informations personnelles </legend>
          <div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="gender">Sexe <span class="star-style">**</span></label>
                <input disabled type="text" class="form-control h-40px" id="gender" [value]="candidate.getGender()"
                  disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="maritalStatus">Situation matrimoniale</label>
                <input type="text" class="form-control h-40px" id="maritalStatus" [value]="candidate.getMaritalStatus()"
                  disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="lastName">Nom <span class="star-style">**</span></label>
                <input type="text" class="form-control h-40px" id="lastName" [value]="candidate.getLastName()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="firstName">Prénom <span class="star-style">**</span></label>
                <input type="text" class="form-control h-40px" id="firstName" [value]="candidate.getFirstName()"
                  disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="dateBirth">Date de naissance <span class="star-style">**</span></label>
                <input type="date" class="form-control h-40px" id="dateBirth" [value]="candidate.getDateBirth()"
                  disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="email">Email <span class="star-style">**</span></label>
                <input type="email" class="form-control h-40px" id="email" [value]="candidate.getEmail()" disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6 my-auto pt-3 pb-3">
                <button *ngIf="candidate.getIdCard() == null" class="btn btn-info w-100" disabled>Afficher
                  CNI/passport</button>
                <a *ngIf="candidate.getIdCard() != null" [href]="candidate.getIdCard()" target="_blank"
                  class="btn btn-info w-100" disabled>Afficher
                  CNI/passport</a>
              </div>
              <div class="form-group col-md-6 my-auto pt-3 pb-3">
                <button *ngIf="candidate.getIdCard() == null" class="btn btn-info w-100" disabled>Afficher CV</button>
                <a *ngIf="candidate.getIdCard() != null" [href]="candidate.getCvPath()" target="_blank"
                  class="btn btn-info w-100">Afficher CV</a>
              </div>
            </div>

            <!-- Div block afficher/reduire -->
            <div id="infoBlock" style="display: none">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="phone1">Téléphone 1 <span class="star-style">**</span></label>
                  <input type="text" class="form-control h-40px" id="phone1" [value]="candidate.getPhone1()" disabled>
                </div>
                <div class="form-group col-md-6">
                  <label for="phone2">Téléphone 2</label>
                  <input type="text" class="form-control h-40px" id="phone2" [value]="candidate.getPhone2()" disabled>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="country">Pays</label>
                  <input class="form-control" id="country" [value]="candidate.getCountry()" disabled>
                </div>
                <div class="form-group col-md-6">
                  <label for="city">Ville</label>
                  <input class="form-control" id="city" [value]="candidate.getCity()" disabled>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="tempWorker">Être intérimaire ?</label>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="radio" id="tempWorkerYes" [checked]="(candidate.getTempWorker() == true)"
                        name="tempWorker" disabled>
                      <label for="tempWorkerYes" style="margin-left: 5px"> OUI</label>
                    </div>
                    <div class="col-md-6">
                      <input type="radio" id="tempWorkerNo" [checked]="(candidate.getTempWorker() == false)"
                        name="tempWorker" disabled>
                      <label for="tempWorkerNo" style="margin-left: 5px"> NON</label>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="driveLicence">Permis de conduire</label>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="radio" id="driveLicenceYes" [checked]="(candidate.getDriverLicence() == true)"
                        name="driverLicence" disabled>
                      <label for="driveLicenceYes" style="margin-left: 5px"> OUI</label>
                    </div>
                    <div class="col-md-6">
                      <input type="radio" id="driveLicenceNo" [checked]="(candidate.getDriverLicence() == false)"
                        name="driverLicence" disabled>
                      <label for="driveLicenceNo" style="margin-left: 5px"> NON</label>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="passport">Passport valide</label>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="radio" id="passportYes" [checked]="(candidate.getPassport() == true)" name="passport"
                        disabled>
                      <label for="passportYes" style="margin-left: 5px"> OUI</label>
                    </div>
                    <div class="col-md-6">
                      <input type="radio" id="passportNo" [checked]="(candidate.getPassport() == false)" name="passport"
                        disabled>
                      <label for="passportNo" style="margin-left: 5px"> NON</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="infoLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('infoBlock', 'infoLabelToShowOrHide')">
              Afficher plus
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Profile recrutement -->
      <!-- <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 50%;">Profil recrutement </legend>
          <div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="profession">Métier <span class="star-style">**</span></label>
                <input class="form-control" id="profession" [value]="candidate.getCandidatesProfiles().getProfessions().getLibelle()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="years_of_experience">Année d'expérience <span class="star-style">**</span></label>
                <input class="form-control" id="years_of_experience" [value]="candidate.getCandidatesProfiles().getYearsOfExperience()" disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="position_level">Niveau de poste <span class="star-style">**</span></label>
                <input class="form-control" id="position_level" [value]="candidate.getCandidatesProfiles().getPositionLevel()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="level_of_study">Niveau d'étude <span class="star-style">**</span></label>
                <input class="form-control" id="level_of_study" [value]="candidate.getCandidatesProfiles().getLevelOfStudy()" disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="training">Formation <span class="star-style">**</span></label>
                <input class="form-control" id="training" [value]="candidate.getCandidatesProfiles().getTrainings().getLibelle()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="availability">Disponibilité</label>
                <input class="form-control" id="availability" [value]="candidate.getCandidatesProfiles().getAvailability()" disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="mobility">Mobilité</label>
                <input class="form-control" id="mobility" [value]="candidate.getCandidatesProfiles().getMobility()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="status">Statut</label>
                <input class="form-control" id="status" [value]="candidate.getCandidatesProfiles().getStatus()" disabled>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="current_salary">Salaire actuel (F CFA)</label>
                <input class="form-control" id="current_salary" [value]="candidate.getCandidatesProfiles().getCurrentSalary()" disabled>
              </div>
              <div class="form-group col-md-6">
                <label for="desired_salary">Salaire souhaité (F CFA)</label>
                <input type="text" class="form-control" id="desired_salary"
                  [value]="candidate.getCandidatesProfiles().getDesiredSalary()" style="height: 40px;" disabled>
              </div>
            </div>
          </div>
        </fieldset>
      </div> -->

      <!-- Experiences -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 30%;">Experiences </legend>
          <div>
            <div id="experienceBlock">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto; height: 450px;">
                <table class="table table-bordered">
                  <tr>
                    <th>Titre du poste</th>
                    <th>Société</th>
                    <th>Niveau de poste</th>
                    <th>Période</th>
                    <th>Manag. equipe</th>
                    <th>Titre sup. N + 1</th>
                    <th>Motif de départ</th>
                    <th>Attest./Certif.</th>
                  </tr>
                  <tr *ngFor="let experience of candidate.getCandidatesExperiences()">
                    <td>{{ experience['job_title'] }}</td>
                    <td>{{ experience['company'] }}</td>
                    <td>{{ experience['position_level'] }}</td>
                    <td>{{ experience['period_start'] }} à <span *ngIf="experience['in_progress']">ce jour</span><span
                        *ngIf="!experience['in_progress']">{{ experience['period_end'] }}</span></td>
                    <td>{{ experience['team_management'] }}</td>
                    <td>{{ experience['supervisor_title'] }}</td>
                    <td>{{ experience['reason_for_leaving'] }}</td>
                    <td><a *ngIf="experience['certificate_path'] != ''"
                        [href]="formatFilePath(experience['certificate_path'])" target="_blank"
                        class="btn btn-info">Voir</a></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Diplômes & formations -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel">
          <legend class="legend-style" style="width: 55%;">Diplômes & formations </legend>
          <div>
            <div id="trainingBlock">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto; height: 450px;">
                <table class="table table-bordered">
                  <tr>
                    <th>Formation</th>
                    <th>Université</th>
                    <th>Periode</th>
                    <th>Niveau d'étude</th>
                    <th>Diplôme</th>
                  </tr>
                  <tr *ngFor="let candidateTraining of candidate.getCandidatesTrainings()">
                    <td>{{ candidateTraining['trainings']['libelle'] }}</td>
                    <td>{{ candidateTraining['university'] }}</td>
                    <td>{{ candidateTraining['period_start'] }} à <span *ngIf="candidateTraining['in_progress']">ce
                        jour</span><span *ngIf="!candidateTraining['in_progress']">{{ candidateTraining['period_end']
                        }}</span></td>
                    <td>{{ candidateTraining['level_of_study'] }}</td>
                    <td><a *ngIf="candidateTraining['diploma_path'] != ''"
                        [href]="formatFilePath(candidateTraining['diploma_path'])" target="_blank"
                        class="btn btn-info">Voir</a></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Langues -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 25%;">Langues </legend>
          <form>
            <div id="languageBlock">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto; height: 250px;">
                <table class="table table-bordered">
                  <tr>
                    <th>Langue</th>
                    <th>Niveau de maitrise</th>
                  </tr>
                  <tr *ngFor="let candidateLanguage of candidate.getCandidatesLanguages()">
                    <td>{{ candidateLanguage['languages']['libelle'] }}</td>
                    <td>{{ candidateLanguage['level'] }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Logiciels -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 35%;">Logiciels </legend>
          <div>
            <div id="skillBlock">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto; height: 250px;">
                <table class="table table-bordered">
                  <tr>
                    <th>Compétence</th>
                    <th>Niveau de maitrise</th>
                  </tr>
                  <tr *ngFor="let candidateSkill of candidate.getCandidatesSkills()">
                    <td>{{ candidateSkill['skills']['libelle'] }}</td>
                    <td>{{ candidateSkill['level'] }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Certificats -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 35%;">Certificats </legend>
          <div>
            <div id="certificatBlock">
              <!-- Liste des ajouts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto; height: 250px;">
                <table class="table table-bordered">
                  <tr>
                    <th>Titre du certificat</th>
                    <th>Certificat</th>
                  </tr>
                  <tr *ngFor="let candidateCertificate of candidate.getCandidatesCertificates()">
                    <td>{{ candidateCertificate['libelle'] }}</td>
                    <td><a *ngIf="candidateCertificate['filePath'] != ''"
                        [href]="formatFilePath(candidateCertificate['filePath'])" target="_blank"
                        class="btn btn-info">Voir</a></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

    </div>

  </div>
</section>
<!-- End service Area -->